import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {EvkOption, MessageCrudService} from "@evomatik/evk-common";
import {ExpedientesConsultasService} from "../../services/expedientes-consultas.service";
import {MatOptionSelectionChange} from "@angular/material/core";
import {ExpedienteCreateService} from "../../services/expediente-create.service";
import {EvkExpedienteModel} from "../../models/evk-expediente.model";
import {take} from "rxjs/operators";
import {EvkExpedienteConfigModel} from "../../models/evk-expediente-config.model";

@Component({
    selector: 'lib-expedientes-create',
    templateUrl: './expedientes-create.component.html',
    styleUrls: ['./expedientes-create.component.css']
})
export class ExpedientesCreateComponent implements OnInit {

    @Output()
    agregarExpediente: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    regresar: EventEmitter<any> = new EventEmitter<any>();

    configuracionExpedienteOptions: EvkOption[] = [];

    idConfiguracion = null;

    expediente: EvkExpedienteModel = new EvkExpedienteModel();
    configExpediente: EvkExpedienteConfigModel = new EvkExpedienteConfigModel();

    constructor(
        public expedientesConsultasService: ExpedientesConsultasService,
        private expedienteCreateService: ExpedienteCreateService,
        private messageCrudService: MessageCrudService,
    ) {
    }

    ngOnInit(): void {
        this.cargarConfiguracion();
    }

    cargarConfiguracion() {
        this.expedientesConsultasService.getExpedienteConfig().subscribe(response => {
            this.configuracionExpedienteOptions = response;
        });
    }

    onChangeSelectConfiguracion(event: MatOptionSelectionChange) {
        this.idConfiguracion = event.source.value;
        this.configExpediente.id = event.source.value;
    }

    continuar() {
        this.expediente.configuracionExpediente = this.configExpediente;
        this.expedienteCreateService.save(this.expediente).pipe(take(1)).subscribe(
            (response) => {
                this.expediente = response.data;
                this.agregarExpediente.emit(this.expediente);
            }, () => {
                this.messageCrudService.snackbarMessage('No se ha podido guardar el expediente');
            }
        );
    }

    goBack() {
        this.regresar.emit();
    }
}
